"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr minmax(645px, 1fr) 1fr;
  grid-template-rows: 1fr;
  justify-content: stretch;
  padding-top: ${({ theme }) => theme.spacings.m};

  & > div:nth-of-type(3) {
    min-height: 200px;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    grid-template-columns: 100%;
    padding-top: 0;
  }
`;
const CoachWrapper = ({ children, className }) => {
    return (0, jsx_runtime_1.jsx)(Wrapper, { className: className, children: children }, void 0);
};
exports.default = CoachWrapper;
//# sourceMappingURL=CoachProfilePageWrapper.js.map